"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixClientDefinition = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.WixClientDefinition = (0, helpers_1.defineService)('viewer-core/viewer-service-wix-client');
//# sourceMappingURL=index.js.map